import { Just, Maybe, Nothing } from "purify-ts/Maybe";
import { MaybeDate } from "../models/date-helpers.models";
import { DateTime } from "luxon";

export const safeToNumber = (x: string | number | null | undefined) => {
  if (x == null || x == undefined) {
    return null
  }
  const result = parseFloat(`${x}`);
  if (isNaN(result)) {
    return null
  }
  return result
}

export const safeToNumberNonZero = (
  x: string | number | null | undefined
): number | null => {
  const result = safeToNumber(x);

  if (result === null || isNaN(result)) {
    return null;
  }

  return result; 
};

export function converterParaRomano(numero: any): string {

  let algarismoRomano;

  if (numero >= 1 && numero <= 3999) {
    const unidades = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
    const dezenas = ['X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC'];
    const centenas = ['C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM'];
    const milhares = ['M', 'MM', 'MMM'];

    const unidade = unidades[numero % 10 - 1];
    const dezena = dezenas[Math.floor(numero % 100 / 10) - 1];
    const centena = centenas[Math.floor(numero % 1000 / 100) - 1];
    const milhar = milhares[Math.floor(numero / 1000) - 1];

    algarismoRomano = (milhar || '') + (centena || '') + (dezena || '') + (unidade || '');
  }
  else {

    algarismoRomano = 'Número fora do intervalo (1-3999)';
  }

  return algarismoRomano;
}

export const getDate = (date: MaybeDate) => {
  if (!date || date == '') {
    return Nothing
  }
  if (!(date instanceof Date)) {
    const result = (new Date(date))
    const obj = DateTime.fromFormat(date, 'yyyy-MM-dd')

    // result.setHours(12)
    return Just(obj.toJSDate())
  }
  return Just(date)
}

// export function getInvertedString(date: MaybeDate)
export function getInvertedString(date: MaybeDate): Maybe<string>
export function getInvertedString(date: MaybeDate, defaultValue?: string): string
export function getInvertedString(date: MaybeDate, defaultValue?: string) {
  const result = Maybe.fromNullable(date)
    .chainNullable(val => {
      if (!(val instanceof Date)) {
        return val;
      }
      const obj = DateTime.fromJSDate(val)
      return obj.toFormat('yyyy-MM-dd')
    })
  if (defaultValue != undefined) {
    return result.orDefault(defaultValue)
  }
  return result
}
